import * as React from 'react';
import './auth-layout.css';

export interface AuthHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
}

/**
 * Header component for auth cards
 * Displays title and optional subtitle
 */
export const AuthHeader: React.FC<AuthHeaderProps> = ({ title, subtitle, className }) => {
  return (
    <div className={`auth-header ${className || ''}`}>
      <h2 className="auth-header-title">{title}</h2>
      {subtitle && <p className="auth-header-subtitle">{subtitle}</p>}
    </div>
  );
};

AuthHeader.displayName = 'AuthHeader';
